import React from 'react'
import styles from './traders.module.css'
import {
    Card, CardImg, CardText, CardBody,
    CardTitle, CardSubtitle, Button
} from 'reactstrap';
export default function WatchCard() {
    return (
        <div style={{ width: '335px', padding: '0px 10px', marginBottom: '70px' }}>
            <Card>
                <section style={{overflow: 'hidden'}}>
                <CardImg className={styles.watchImg} top width="100%" src="https://pics.zeitauktion.com/2022/2203349_sw6_cover_2k.jpg" alt="Card image cap" />
                </section>
                <CardBody>
                    <CardTitle className={styles.brand}>Rolex</CardTitle>
                    <CardSubtitle className={styles.model}>Daytona</CardSubtitle>
                    <CardText><span className={styles.desc} style={{color: "#a9a9a9"}}>ROLEX DAYTONA CHRONOGRAPH CERAMIC / STEEL AUTOMATIC MEN'S WATCH 116500LN [2201641]</span>
                        <br />
                        <div className='d-flex justify-content-between'>
                            <span>
                                <strong>
                                €39,650
                                </strong>
                            </span>
                            <span>
                                30/5/2022
                            </span>
                        </div>
                    </CardText>
                    <button
                        className={`btn-block btn-buy checkout btn btn-secondary ${styles.btnDark} `}
                    >
                        Yes, I want it
                    </button>
                </CardBody>
            </Card>
        </div>
    )
}
